module.exports = __webpack_public_path__ + "static/media/icon-arrow.04e48505.svg";